import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  token_type: "Bearer",
  expires_in: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      const { user, token, token_type, expires_in } = action.payload;
      state.user = user;
      state.token = token;
      state.token_type = token_type ?? "Bearer";
      state.expires_in = expires_in ?? null;
      state.isAuthenticated = Boolean(token && user);
    },
    updateProfile(state, action) {
      if (!state.user) return;
      state.user = { ...state.user, ...action.payload };
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.token_type = "Bearer";
      state.expires_in = null;
      state.isAuthenticated = false;
    },
  },
});

export const { loginSuccess, updateProfile, logout } = authSlice.actions;
export default authSlice.reducer;
